import { deepObjectMerge } from "@/util/utils.js";
import base from "./base";
import table from "./table";
import pages from "./pages";
import common from "./common";
import tips from "./tips";
import protocol from "./protocol.js";

export default deepObjectMerge(base, table, pages, common, tips, protocol);
